/**
 * 系统Action常量
 *
 * Created by XuDL(Wisea) on 2016/08/24
 */
;
(function (window, $, undefined) {
  // 取得工程目录
  var localObj = window.location;
  var rootDomain = localObj.protocol + "//" + localObj.host;
  console.log(process.env.BUILD_FLAG)
  if (process.env.BUILD_FLAG === 'test') {//测试部署
    var basePath = rootDomain ;
    var commonUrl = rootDomain+"/sr/";
    // var commonUrl = 'http://192.168.20.208:18010/sr/';
    // var basePath = 'http://192.168.20.208:18010';
  } else if (process.env.BUILD_FLAG === 'production') {//生产环境部署
    var commonUrl = rootDomain+"/sr/";
    var basePath = rootDomain;
    // var commonUrl = 'http://192.168.20.208:18010/sr/';
    // var basePath = 'http://192.168.20.208:18010';
  } else if (process.env.BUILD_FLAG === 'local') {//本地部署
 
  } else {//本地开发环境
    var commonUrl = 'http://192.168.20.208:18010/sr/';
    var basePath = 'http://192.168.20.208:18010';
    // var basePath = 'http://192.168.101.65:2147';

  };
  // 接口调用
  var Action = {
    "SECURITY_W_LOGOUT": basePath+ "/mdb/w/logout",//退出
    // xuyaohua
    "Login": basePath +"/mdb/login?ltype=quaSafPortal",//登录
    'MOBILE_VALCODE_CREATE' : basePath+ '/mobile/valCode/create',//发送验证码
    'REGISTERUSER' : basePath+ '/mdb/n/qualitySaf/user/registerUser',//注册
    'UNLOGIN_FINDUSERBYMOBILE' : basePath+ '/mdb/n/qualitySaf/user/mobileCheck',//查找注册用户是否存在
    'USER_CHECKHECKFORFOGETPWD' : basePath+ '/mdb/n/qualitySaf/user/checkheckForFogetPwd',//忘记密码查找注册用户是否存在
    'MOBILE_VALCODE_CREATE' : basePath+ '/mdb/mobile/valCode/create',// 发送验证码
    'USER_FORGETPWDSAVE' : basePath+ '/mdb/n/qualitySaf/user/forgetPwdSave',//忘记密码提交
    'FLOORINDEX_GETFLOORINDEXSHOWOTHER' : basePath+ '/dc/n/floorIndex/getFloorIndexShowOther',//标题查询
    'FLOORINDEX_GETFLOORINDEXSHOWFLAVOR' : basePath+ '/dc/n/floorIndex/getFloorIndexShowFlavor',//首页-特色产品风味谱图产品列表
    'FLOORINDEX_GETFLOORINDEXSHOWFLAVORDETAIL' : basePath+ '/dc/n/floorIndex/getFloorIndexShowFlavorDetail',//首页-特色产品风味谱图详细信息
    'ABOUT_LIST' : basePath+ '/dc/n/protal/about/list',//关于我们列表
    'PLATF_PORTALCOLUMNLIST' : basePath+ '/dc/n/protal/platf/portalColumnList',//获取科普、新闻对应平台栏目管理列表
    'PLATF_FINDBEECOLUMNLIST' : basePath+ '/dc/n/protal/platf/findBeeColumnList',//获取蜂产品栏目管理列表
    'PROTAL_BEE_PAGE' : basePath+ '/dc/n/protal/bee/page',//获取蜂产品栏目管理列表新闻动态
    'PLATF_FINDPORTALPAGEBYIDS' : basePath+ '/dc/n/protal/platf/findPortalPageByIds',//前端门户接口->获取同产品类型的科普交流、新闻动态文章列表 必填字段:columnType
    'PGEO_GEOTYPEPAGE' : basePath+ '/dc/n/protal/pGeo/geoTypePage',//首页地标专题->中欧互认地理标志产品目录
    'PROTAL_PLATF_PORTALPAGE' : basePath+ '/dc/n/protal/platf/portalPage',//获取科普、新闻分页列表
    'PLATF_PORTALLIST' : basePath+ '/dc/n/protal/platf/portalList',//热点新闻
    'PLATF_GETPORTAL' : basePath+ '/dc/n/protal/platf/getPortal',//热点新闻闲情
    'PROTAL_ADVER_LIST' : basePath+ '/dc/n/protal/adver/list',//
    'REPLENISH_OVERVIEW' : basePath+ '/dc/replenish/overview',//门户统计的6组数字
    'FLOORINDEX_GETFOORINDEXSHOWSCIENCE' : basePath+ '/dc/n/floorIndex/getFoorIndexShowScience',
    'PROTAL_PLATF_NEWMSG' : basePath+ '/dc/n/protal/platf/newMsg',//获取新闻动态->首个栏目->最新文章信息
    'FLOORINDEX_INDEXSHOWFLAG' : basePath+ '/dc/n/floorIndex/indexShowFlag',//获取模块是否显示
    'UPLOAD_IMG' : basePath+ '/w/uploadImg',//上传图片
    'UNLOGINSEACHER_UPLOADIMG' : basePath+ '/hxhyapi/unLoginSeacher/uploadImg',//无权限上传图片
    'UNLOGIN_INSERT' : basePath+ '/hxhyapi/unLogin/insert',//新增意见反馈无权限
    'REPLENISH_SELGEOCOUNT' : basePath+ '/dc/replenish/selGeoCount',//黑龙江
    'FLOORINDEX_GETAREARECDLIST' : basePath+ '/dc/n/floorIndex/getAreaRecdList',//区域特色产品推荐

    'REPLENISH_SELMTYXCOUNT' : basePath+ '/dc/replenish/selMtyxCount',//名特优新农产品


    


    'REPLENISH_FINDCHILDRENLISTANDSELFBYPID' : basePath+ '/dc/replenish/findChildrenListAndSelfByPid',//蜂产品地理分布列表
    'FLOORINDEX_GETFIUNDEXSEASONLIST' : basePath+ '/dc/n/floorIndex/getFIndexSeasonList',//地区-时令产品推荐
    'PROTAL_PGEO_LISTGEO' : basePath+ '/dc/n/protal/pGeo/listGeo',//获取前端首页门户->新增需求->产品管理分页列表
    'REPLENISH_PGEO_FNYP' : basePath+ '/dc/replenish/pGeo/fnyp',
    'PROTAL_PGEO_GET' : basePath+ '/dc/n/protal/pGeo/get',//查询门户产品管理
    'BEETOPIC_SELGEOCOUNT':  basePath + '/mdb/beeTopic/selGeoCount', //蜂产品地理标志认证数量
    'BEETOPIC_SAMPLECOUNT':  basePath + '/mdb/beeTopic/sampleCount', //蜂产品入库样品总数
    'BEETOPIC_OVERVIEW':  basePath + '/mdb/beeTopic/overview', //特征数据总量
    'SELGEOCOUNT' : basePath+ '/dc/replenish/selGeoCount',//地理标志产品
    'SAMPLECOUNT' : basePath+ '/dc/replenish/sampleCount',//入库样品总数
    // 首页产品推荐
    'GETINDEXSHOWSEASON' : basePath+ '/dc/n/floorIndex/getFIndexShowSeason',//获取首页产品推荐-时令
    'GETINDEXSHOWAREARECD' : basePath+ '/dc/n/floorIndex/getFIndexShowAreaRecd',//获取首页产品推荐-区域
    'GETINDEXSHOWPROCLASS' : basePath+ '/dc/n/floorIndex/getFIndexShowProClass',//获取首页产品推荐-产品分类
    'FINDFRECINDEXLIST' : basePath+ '/dc/n/floorIndex/findFRecIndexList',//获取首页产品推荐-指标推荐
    'PROTALFILLLIST' : basePath+ '/dc/n/protal/fill/list',//获取首页风险管控
    'FINDPORTALFILLPAGE' : basePath+ '/dc/n/protal/fill/findPage',//获取风险管控列表首页
    'FINDPORTALFILLLIST' : basePath+ '/dc/n/protal/fill/list',//获取风险管控列表分页
    'FINDPORTALFILLGET' : basePath+ '/dc/n/protal/fill/get',//获取风险管控详情
    'FINDCLASSMAGETREE' : basePath+ '/dc/replenish/findClassMageTree',//获取农产品分类树
    'GETSEARCHKEY' : basePath+ '/dc/n/protal/fill/getSearchKey',//门户前台-风险管控产品热搜字信息
    // zql
    'PGEO_FINDPORTALPAGE' : basePath+ '/dc/n/protal/pGeo/findPortalPage',//获取前端首页门户->产品管理分页列表
    'AREA_LIST' : basePath+ '/dc/n/protal/pGeo/address',//获取前端首页门户->产品管理省市
    'PGEO_LIST' : basePath+ '/dc/n/protal/pGeo/list',//查询门户产品坐标点/产品查询模糊列表
    'PRODUCTCLASSMAGE_FINDCLASSMAGETREE' : basePath+ '/dc/replenish/findClassMageTree',//农产品分类
    'PRODUCTCLASSMAGE_FINDCLASSMAGETREEFORLEVEL' : basePath+ '/dc/replenish/findClassMageTreeForLevel',//农产品分类
    'PGEO_GET' : basePath+ '/dc/n/protal/pGeo/get',//查询门户产品管理详情
    'PLATFINFOMAGE_PORTALLIST' : basePath+ '/dc/n/protal/platf/portalList',//前端门户接口->科普交流、新闻动态热点排行管理列表
    'FLOORINDEX_GETFINDEXSHOWAREAMAP' : basePath+ '/dc/n/floorIndex/getFindexShowAreaMap',//首页- 地理标志
    'GETFLOORINDEXSHOWOTHER' : basePath+ '/dc/n/floorIndex/getFloorIndexShowOther',//首页-(风险管控/分类及指标设置/农产品地理查询配置)标题查询
    'FLOORINDEX_FINDMAPLISTFORPROAREA' : basePath+ '/dc/n/floorIndex/findMapListForProArea',//首页-农产品地理查询地图信息
    'REPLENISH_FINDCLASSMAGETREE' : basePath+ '/dc/replenish/findClassMageTree',//产品tree
    'FLOORINDEX_FINDPROCLASSCHILDLIST' : basePath+ '/dc/n/floorIndex/findProClassChildList',//首页-农产品地理查询-产品类型下所有的产品列表
    'AREA_LINKAGELIST' : basePath+ '/mdb/area/linkageList',//省
    'REPLENISH_SELCHEMICALSEARCH' : basePath+ '/dc/replenish/chemicalSearchNoPage',//查询化合物不分页
    'PGEO_FINDPORTALLIST' : basePath+ '/dc/n/protal/pGeo/findPortalList',//查询门户产品坐标点列表
    'N_ALLONELIST' : basePath+ '/mdb/n/allOneList',//风味品质特征指标
    'PGEO_PAGELIST' : basePath+ '/dc/n/protal/pGeo/pageList',//产品管理分页列表
    //zcx
    'REPLENISH_SELPINDEXAVGLIST' : basePath+ '/dc/replenish/selPindexAvgList',//特征指标查询
    'REPLENISH_RANKINGVARIETLIST' : basePath+ '/dc/replenish/rankingVarietList',//首页 - 根据选定的产品品类和特征指标进行排行 - 查询品种信息信息
    'REPLENISH_RANKINGPRODUCTLIST' : basePath+ '/dc/replenish/rankingProductList',//首页 - 根据选定的产品品类和特征指标进行排行 - 查询产品信息
    'REPLENISH_RANKINGCATGBEELIST' : basePath+ '/dc/replenish/rankingCatgBeeList',//首页 - 根据选定的产品品类和特征指标进行排行 - 查询产品信息
    'REPLENISH_RANKINGCATGLIST' : basePath+ '/dc/replenish/rankingCatgList',//首页 - 根据选定的产品品类和特征指标进行排行 - 查询品类信息
    'FLOORCONFMAGE_OTHERFLOORINFO' : basePath+ '/dc/replenish/otherFloorInfo',// 一楼以外的其他楼层配置
    'MDB_N_ALLONELIST' : basePath+ '/mdb/n/allOneList',// 查询指标列表
    'REPLENISH_CHEMICALSEARCHNOPAGE' : basePath+ '/dc/replenish/chemicalSearchNoPage',// 查询指标列表select
    'REPLENISH_SELCHEMICALSEARCH' : basePath+ '/dc/replenish/chemicalSearchNoPage',// 根据选定的产品品类和特征指标进行排行 - 查询指标信息
    'REPLENISH_FINDCLASSMAGETREE' : basePath+ '/dc/replenish/findClassMageTree',// 获取农产品分类树结构
    'PROTAL_PGEO_FINDPORTALPAGE' : basePath+ '/dc/n/protal/pGeo/findPortalPage',// 产品管理分页列表
    'POFTENINDEX_FINDLIST' : basePath+ '/mdb/n/findList',// 产品管理分页列表
    'POFTENINDEX_FINDPAGELIST':  basePath + '/mdb/n/findList', //分页查询常用指标列表
    'PROTAL_LSSPAGE':  basePath + '/dc/n/protal/lssPage', //分页查询常用指标列表
    'USER_GETDETAILBYID':  basePath + '/mdb/n/qualitySaf/user/getDetailById', //获取提交人信息
    'UNLOGIN_VISITS':  basePath + '/dc/replenish/visits', //信息概览
    'PROTAL_GETURL':  basePath + '/dc/n/protal/getUrl', //二维码
    'REPLENISH_SELMTYXCOUNT':  basePath + '/dc/replenish/selMtyxCount', //名特优选统计
    'MEDICINAL_SELGEOCOUN':  basePath + '/mdb/medicinal/selGeoCount', //中药材地理标志认证数量
    'MEDICINAL_SAMPLECOUNT':  basePath + '/mdb/medicinal/sampleCount', //中药材入库样品总数
    'MEDICINAL_OVERVIEW':  basePath + '/mdb/medicinal/overview', //中药材特征数据总量
    'MEDICINAL_FINDPGEOLIST':  basePath + '/mdb/medicinal/findPgeoList', //中药材-热门中药材
    "W_MEDICINALCLASSMAGE_FINDCLASSMAGETREE" : basePath  + '/dc/n/findClassMageTree',//获取中药材分类树结构

// zql
'PGEO_FINDPORTALPAGE' : basePath+ '/dc/n/protal/pGeo/findPortalPage',//获取前端首页门户->产品管理分页列表
'AREA_LIST' : basePath+ '/dc/n/protal/pGeo/address',//获取前端首页门户->产品管理省市
'PGEO_LIST' : basePath+ '/dc/n/protal/pGeo/list',//查询门户产品坐标点/产品查询模糊列表
'PRODUCTCLASSMAGE_FINDCLASSMAGETREE' : basePath+ '/dc/replenish/findClassMageTree',//农产品分类

'PRODUCTCLASSMAGE_FINDCLASSMAGETREEFORLEVEL' : basePath+ '/dc/replenish/findClassMageTreeForLevel',//农产品分类
'PGEO_GET' : basePath+ '/dc/n/protal/pGeo/get',//查询门户产品管理详情
'PLATFINFOMAGE_PORTALLIST' : basePath+ '/dc/n/protal/platf/portalList',//前端门户接口->科普交流、新闻动态热点排行管理列表
'FLOORINDEX_GETFINDEXSHOWAREAMAP' : basePath+ '/dc/n/floorIndex/getFindexShowAreaMap',//首页- 地理标志

'GETFLOORINDEXSHOWOTHER' : basePath+ '/dc/n/floorIndex/getFloorIndexShowOther',//首页-(风险管控/分类及指标设置/农产品地理查询配置)标题查询
'FLOORINDEX_FINDMAPLISTFORPROAREA' : basePath+ '/dc/n/floorIndex/findMapListForProArea',//首页-农产品地理查询地图信息
'REPLENISH_FINDCLASSMAGETREE' : basePath+ '/dc/replenish/findClassMageTree',//产品tree
'FLOORINDEX_FINDPROCLASSCHILDLIST' : basePath+ '/dc/n/floorIndex/findProClassChildList',//首页-农产品地理查询-产品类型下所有的产品列表






'AREA_LINKAGELIST' : basePath+ '/mdb/area/linkageList',//省
'REPLENISH_SELCHEMICALSEARCH' : basePath+ '/dc/replenish/chemicalSearchNoPage',//查询化合物不分页
'PGEO_FINDPORTALLIST' : basePath+ '/dc/n/protal/pGeo/findPortalList',//查询门户产品坐标点列表
'N_ALLONELIST' : basePath+ '/mdb/n/allOneList',//风味品质特征指标
'PGEO_PAGELIST' : basePath+ '/dc/n/protal/pGeo/pageList',//产品管理分页列表

//zcx

'REPLENISH_SELPINDEXAVGLIST' : basePath+ '/dc/replenish/selPindexAvgList',//特征指标查询
'REPLENISH_RANKINGVARIETLIST' : basePath+ '/dc/replenish/rankingVarietList',//首页 - 根据选定的产品品类和特征指标进行排行 - 查询品种信息信息
'REPLENISH_RANKINGPRODUCTLIST' : basePath+ '/dc/replenish/rankingProductList',//首页 - 根据选定的产品品类和特征指标进行排行 - 查询产品信息
'REPLENISH_RANKINGCATGBEELIST' : basePath+ '/dc/replenish/rankingCatgBeeList',//首页 - 根据选定的产品品类和特征指标进行排行 - 查询产品信息
'REPLENISH_RANKINGCATGLIST' : basePath+ '/dc/replenish/rankingCatgList',//首页 - 根据选定的产品品类和特征指标进行排行 - 查询品类信息
'FLOORCONFMAGE_OTHERFLOORINFO' : basePath+ '/dc/replenish/otherFloorInfo',// 一楼以外的其他楼层配置
'MDB_N_ALLONELIST' : basePath+ '/mdb/n/allOneList',// 查询指标列表
'REPLENISH_CHEMICALSEARCHNOPAGE' : basePath+ '/dc/replenish/chemicalSearchNoPage',// 查询指标列表select
'REPLENISH_SELCHEMICALSEARCH' : basePath+ '/dc/replenish/chemicalSearchNoPage',// 根据选定的产品品类和特征指标进行排行 - 查询指标信息
'REPLENISH_FINDCLASSMAGETREE' : basePath+ '/dc/replenish/findClassMageTree',// 获取农产品分类树结构
'PROTAL_PGEO_FINDPORTALPAGE' : basePath+ '/dc/n/protal/pGeo/findPortalPage',// 产品管理分页列表
'POFTENINDEX_FINDLIST' : basePath+ '/mdb/n/findList',// 产品管理分页列表
'POFTENINDEX_FINDPAGELIST':  basePath + '/mdb/n/findList', //分页查询常用指标列表
'PROTAL_LSSPAGE':  basePath + '/dc/n/protal/lssPage', //分页查询常用指标列表
'USER_GETDETAILBYID':  basePath + '/mdb/n/qualitySaf/user/getDetailById', //获取提交人信息
'UNLOGIN_VISITS':  basePath + '/dc/replenish/visits', //信息概览
'PROTAL_GETURL':  basePath + '/dc/n/protal/getUrl', //二维码
'REPLENISH_SELMTYXCOUNT':  basePath + '/dc/replenish/selMtyxCount', //名特优选统计

"W_MEDICINALCLASSMAGE_FINDCLASSMAGETREE" : basePath  + '/dc/n/findClassMageTree',//获取中药材分类树结构
"FINDCHILDRENLISTANDSELFBYPID" : basePath  + '/dc/n/findProClassChildList',//获取中药材列表

"MEDICINAL_RANKINGMEDICINALLIST" : basePath  + '/mdb/medicinal/rankingMedicinalList',//

"LSSCONFIGMAGE_PAGE" : basePath  + '/dc/replenish/page',//专题项目名称
"PROTAL_ADVERSPACELIST" : basePath  + '/dc/n/protal/adverSpacelist',//获取id类型展示调查问卷

'REPLENISH_RANKINGCATGLISTWF':  basePath + '/dc/replenish/rankingCatgListWf', //潍坊排行榜






 





    


    



    

    

  };
  // 设置给全局
  window.Action = Action;
  window.basePath = basePath;
  window.commonUrl = commonUrl;
  window.rootDomain = rootDomain;//浏览器域名地址

})(window, window.jQuery);



//////////////////
// WEBPACK FOOTER
// ./static/js/OstPaths.js
// module id = DsXP
// module chunks = 43